import { createFileRoute } from '@tanstack/react-router'

/**
 * /orgs/$orgId/groups/$groupId — group selected, no report open: the URL of the NAV STACK's middle level,
 * the group's users list, with the report one push further in. A real route rather than a search-param flag
 * is what lets browser Back pop the stack, keeps the level deep-linkable, and separates "opened the group"
 * from "asked for its report". It renders nothing into the report Outlet: on mobile that pane is off-stage,
 * on desktop it is the empty detail pane. The `groups.$groupId` layout above owns the chrome prefetch, so
 * this leaf needs no loader.
 */
export const Route = createFileRoute('/_app/orgs/$orgId/groups/$groupId/')({})
